
import layout from '~/mixins/layout'
/* eslint-disable vue/component-definition-name-casing */
import Layout from '~/layouts/wide'
export default {
    ...Layout,
    name: 'wide',
    mixins: [layout],
}
